var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-selects-group-wpr"
  }, [_c('search-down-list', {
    ref: "select",
    attrs: {
      "disabled": _vm.disabled,
      "leftFormater": _vm.leftFormater,
      "rightFormater": _vm.rightFormater,
      "cacheOptions": _vm.cacheList,
      "allowEmail": _vm.allowEmail
    },
    model: {
      value: (_vm.userValues),
      callback: function($$v) {
        _vm.userValues = $$v
      },
      expression: "userValues"
    }
  }, [_c('i', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hideGroup),
      expression: "hideGroup"
    }],
    staticClass: "el-icon-menu group-btn",
    style: (_vm.disabled ? 'cursor: not-allowed;' : ''),
    attrs: {
      "title": "分组"
    },
    on: {
      "click": _vm.toggleGroup
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-plus save-to-group",
    style: (_vm.disabled ? 'cursor: not-allowed;' : ''),
    attrs: {
      "title": "新加分组"
    },
    on: {
      "click": _vm.addToGroup
    }
  })]), _vm._v(" "), (_vm.showGroupTable) ? _c('div', {
    staticClass: "group-info"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.gridData
    },
    on: {
      "row-click": _vm.rowClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "recordName",
      "label": "组名",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "data",
      "label": "成员"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((JSON.parse(scope.row.record)), function(item, index) {
          return _c('el-tag', {
            key: index,
            attrs: {
              "type": "primary"
            }
          }, [_vm._v(_vm._s(item.title || item.name))])
        })
      }
    }], null, false, 3967572706)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "50",
      "prop": "recordName",
      "label": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "float": "right",
            "font-size": "14px"
          },
          style: (_vm.disabled ? 'cursor: not-allowed;' : ''),
          attrs: {
            "type": "text",
            "icon": "el-icon-close"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.removeItem(scope.row.id)
            }
          }
        })]
      }
    }], null, false, 1306990467)
  })], 1)], 1) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e888f0a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/userSelect/userSelect.vue
// module id = null
// module chunks = 